/**
 * Use this file for any custom analytics scripts, functions, datalayer pushes, etc.
 * If you don't need it, remember to remove its corresponding `wp_enqueue_script()` from `functions.php`
 *
 * The dataLayer and gtag functions are already initialized directly in `header.php`, as part of Consent Mode.
 */
// Init dataLayer
window.dataLayer = window.dataLayer || [];

jQuery(document).ready(function($) {

  /**
   * Cookie banner
   */
    // Get instance of banner
  const $mythrilCookieBanner = $('#mythril-cookie-banner');
  if ($mythrilCookieBanner.length) {

    // Simple script to hide banner and set localStorage
    if (localStorage.getItem('cookie_accepted')) {
      // Update consent state according to previous acceptance
      if (areCookiesAccepted()) {
        consentGranted();
        $mythrilCookieBanner.remove();

      } else {
        // If consent was denied, check if it's been a week
        const deniedUntil = localStorage.getItem('cookie_denied_until');
        const deniedDate  = new Date(parseInt(deniedUntil));

        if (deniedUntil) {
          if ( new Date() >= deniedDate ) {
            localStorage.removeItem('cookie_accepted');
            $mythrilCookieBanner.toggleClass(['show','hide']);
          } else {
            consentDenied();
          }
          // If no "deny until" date exists, just show the banner again
        } else {
          $mythrilCookieBanner.toggleClass(['show', 'hide']);
        }
      }

    } else {
      // Otherwise, user hasn't decided so remove 'hide' and add 'show' to trigger fade
      $mythrilCookieBanner.toggleClass(['show', 'hide']);
    }
  }

});

/**
 * Functions
 */
window.acceptCookies = function() {
  localStorage.setItem('cookie_accepted', 'true');
  consentGranted();
}

window.rejectCookies = function() {
  localStorage.setItem('cookie_accepted', 'false');
  consentDenied();
}

window.areCookiesAccepted = function() {
  return ('true' === localStorage.getItem('cookie_accepted'));
}

window.consentGranted = function() {
  gtag('consent', 'update', {
    'ad_storage': 'granted',
    'ad_user_data': 'granted',
    'ad_personalization': 'granted',
    'analytics_storage': 'granted'
  });
  window.dataLayer.push({ 'event': 'consent_granted' });
}

window.consentDenied = function() {
  let weekFromNow = new Date();
  weekFromNow.setDate(weekFromNow.getDate() + 7);
  localStorage.setItem('cookie_denied_until', weekFromNow.getTime());

  gtag('consent', 'update', {
    'ad_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'analytics_storage': 'denied'
  });
  window.dataLayer.push({ 'event': 'consent_denied' });
}